import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabelSystem, finalIncludedItems, trackCheckout } from '../data/offer';
const noMoreItems = ['No more Sunday nights searching for running progressions that actually work', 'No more sessions that feel rushed or improvised', 'No more athletes losing motivation because workouts feel repetitive', 'No more weekends lost to planning instead of living', "No more walking to the track wishing you'd been better prepared"];
export function FinalCTA() {
  return <section className="py-20 md:py-24 px-4 bg-charcoal text-white" data-id="element-116" data-mp="vv9o3eoqxblf">
      <div className="max-w-4xl mx-auto" data-id="element-117" data-mp="vwkrvei6yjcj">
        <div className="text-center mb-14" data-id="element-118" data-mp="qvf1hnc07866">
          <h2 className="text-3xl md:text-5xl font-display font-bold uppercase mb-8 leading-tight" data-id="element-119" data-mp="qxrpah4g0cr5">
            Next Monday you could still be building your sessions from
            scratch...
            <br data-id="element-120" data-mp="zua5csrks66b" />
            <span className="text-orange" data-id="element-121" data-mp="2c4o9ar3rqx3k">
              Or you could walk to every training session completely prepared.
            </span>
          </h2>
          <ul className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-graphite p-8 rounded-2xl border border-white/10" data-id="element-122" data-mp="2h4j0ywvdbqpo">
            {noMoreItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-123" data-mp="2r2gnnfxkxfg6">
                <ArrowRightIcon size={18} className="text-orange shrink-0 mt-1" aria-hidden="true" data-id="element-124" data-mp="2qzkoxpdwqmqo" />
                <span className="text-white/80" data-id="element-125" data-mp="3010zpy8mwqvf">{item}</span>
              </li>)}
          </ul>
          <p className="text-xl text-white mb-2" data-id="element-126" data-mp="34u3wsgcmeigd">
            Being a great coach isn&apos;t created by Hybrid Race Coach Ready.
          </p>
          <p className="text-2xl font-bold text-orange mb-6" data-id="element-127" data-mp="3errtvcxp821p">
            You&apos;re already a great coach.
          </p>
          <p className="text-xl text-white/70" data-id="element-128" data-mp="3isblk0zi6dgg">
            What Hybrid Race Coach Ready does is give you the time and tools to
            make that greatness visible in every session you coach.
          </p>
        </div>

        <div className="bg-ivory border-2 border-orange rounded-3xl p-6 md:p-12 shadow-2xl" data-id="element-129" data-mp="1eqtkjg8wwr5n">
          <h3 className="text-2xl font-bold uppercase text-charcoal mb-6 text-center border-b border-sand-deep pb-6 font-display" data-id="element-130" data-mp="1shggx1r7a4yk">
            Everything included in the 6-in-1 system
          </h3>

          <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-2.5 mb-10" data-id="element-131" data-mp="22djo4m0wstsd">
            {finalIncludedItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-132" data-mp="1xhuic0yaqgnm">
                <CheckIcon size={16} className="text-orange shrink-0 mt-0.5" aria-hidden="true" data-id="element-133" data-mp="2be7zta2tyi23" />
                <span className="text-charcoal text-sm" data-id="element-134" data-mp="h0ym16394ae1">{item}</span>
              </li>)}
          </ul>

          <div className="text-center" data-id="element-135" data-mp="d0oj62ara03e">
            <p className="mb-8 p-6 bg-sand rounded-xl border border-copper/40 italic text-charcoal text-lg" data-id="element-136" data-mp="d1pvsb7f6un8">
              &quot;The best time to have this complete coaching system was
              before your first hybrid racing session.
              <br data-id="element-137" data-mp="3pc2kb23ymzvl" />
              <span className="text-orange font-bold not-italic" data-id="element-138" data-mp="3pahprchnbgxq">
                The second best time is today.
              </span>
              &quot;
            </p>
            <p className="text-xl font-display font-bold uppercase text-charcoal mb-2" data-id="element-139" data-mp="3fdms0vt75kki">
              Hybrid Race Coach Ready — Complete 6-in-1 Coaching System
            </p>
            <p className="text-sm text-warmgray mb-8" data-id="element-140" data-mp="3ka3ezmontsw0">
              120 ready-to-coach sessions designed to help coaches plan less,
              coach with confidence and keep every session truly structured and
              fresh.
            </p>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-lg md:text-xl py-5 px-10 mb-6" data-id="element-141" data-mp="14md6mseztk4h">
              {ctaLabelSystem}
              <ArrowRightIcon size={20} aria-hidden="true" data-id="element-142" data-mp="35l6zyi1lhtdz" />
            </Button>
            <ul className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-warmgray" data-id="element-143" data-mp="30p9ho66rucyk">
              <li data-id="element-144" data-mp="2vnk68pfmzx9y">7-Day Money-Back Guarantee</li>
              <li data-id="element-145" data-mp="2robbpicrvvdc">Secure Payment</li>
              <li data-id="element-146" data-mp="2rn8mrfz0g302">Instant Access</li>
              <li data-id="element-147" data-mp="2rq4o7ea2h9t9">Pay in Your Local Currency</li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}